import { useAtomValue } from "jotai";

import { appBarFixedHeaderHeightAtom, appBarStickyAtom } from "./atoms";

export const useAppBarStickyHeightValue = () => {
  const appBarSticky = useAtomValue(appBarStickyAtom);
  const fixedHeaderHeight = useAtomValue(appBarFixedHeaderHeightAtom);
  return {
    /**
     * This value of the app bar height
     */
    appBarHeight: appBarSticky.appBarHeight,
    /**
     * This value is the actual height of the app bar when it's in position sticky.
     * When the app bar container is translated away and replaced by a fixed header
     * (e.g. the home mini header), the fixed header height is used instead.
     */
    appBarStickyHeight: Math.max(appBarSticky.stickyHeight, fixedHeaderHeight),
  };
};
